import VideoSectionPage from '../components/VideoSectionPage';

export default function TemoignagesPage() {
  return (
    <VideoSectionPage
      section="temoignages"
      sidebarLabel="TÉMOIGNAGES PAR ANNÉE"
      renderKey="byYear"
      videoTitlePrefix={null}
      showThemeFilter={false}
      multipleVideosPerDay={true}
    />
  );
}
